import { create } from "zustand";
import Logger from "../log/Logger";
import AppNavigator from "../navigation/AppNavigator";
import SessionStorageService from "core/authUser/auth/services/sessionStorageService/SessionStorageService";
import Env from "core/env/Env";

export interface AppState {
  // Core services
  logger: Logger;
  navigator: AppNavigator;
  sessionStorageService: SessionStorageService;

  // Actions
  initializeLogger: (env: Env) => void;
  setNavigator: (navigator: AppNavigator) => void;
  setSessionStorageService: (service: SessionStorageService) => void;
}

export const useAppStore = create<AppState>((set, get) => ({
  // Initial state
  logger: Logger.getInstance(),
  navigator: {} as AppNavigator, // Will be set during initialization
  sessionStorageService: {} as SessionStorageService, // Will be set during initialization

  // Actions
  initializeLogger: (env: Env) => {
    const { logger } = get();
    logger.defineLogActivity(env);
  },

  setNavigator: (navigator: AppNavigator) => {
    set({ navigator });
  },

  setSessionStorageService: (service: SessionStorageService) => {
    set({ sessionStorageService: service });
  },
}));
